import * as React from "react";
import {SortDir} from "../../../../utils/listUtil";

export interface SortState {
    col: string;
    dir: SortDir;
}

export const SortIcon: React.FC<{ col: string; active: string; dir: SortDir }> = ({col, active, dir}) => {
    const visible = col === active;
    return (
        <i
            className={`fa-light fa-chevron-${dir === "asc" ? "up" : "down"} admin-analytics__sort-icon`}
            aria-hidden="true"
            style={{visibility: visible ? "visible" : "hidden"}}
        />
    );
};

interface ISortableThProps {
    col: string;
    label: React.ReactNode;
    sortState: SortState;
    setSort: (s: SortState) => void;
    extraClass?: string;
    defaultDir?: SortDir;
}

export const SortableTh: React.FC<ISortableThProps> = (
    {col, label, sortState, setSort, extraClass, defaultDir = "desc"},
) => {
    const isActive = sortState.col === col;
    const handleClick = () => setSort({
        col,
        dir: isActive ? (sortState.dir === "desc" ? "asc" : "desc") : defaultDir,
    });
    const handleKey = (e: React.KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
        }
    };
    return (
        <th
            className={`admin-analytics__th--sortable${extraClass ? ` ${extraClass}` : ""}`}
            onClick={handleClick}
            onKeyDown={handleKey}
            tabIndex={0}
            role="columnheader"
            aria-sort={isActive ? (sortState.dir === "asc" ? "ascending" : "descending") : undefined}
        >
            {label} <SortIcon col={col} active={sortState.col} dir={sortState.dir}/>
        </th>
    );
};

export const sortTh = (
    col: string,
    label: React.ReactNode,
    sortState: SortState,
    setSort: (s: SortState) => void,
    extraClass?: string,
    defaultDir: SortDir = "desc",
) => (
    <SortableTh
        col={col} label={label} sortState={sortState} setSort={setSort}
        extraClass={extraClass} defaultDir={defaultDir}
    />
);
